import Typography from '@mui/material/Typography'
import React from 'react'
import { Link } from 'react-router-dom'

import TotpGuard from '@/app/component/guard/totp'
import CardLayout from '@/app/component/layout/card'
import ErrorLayout from '@/app/component/layout/error'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import Billing, { Tabs } from '@/app/module/payments/component'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps<{
    tabName: string
  }>
}

export default function BillingPage({ match }: Props) {
  const { tabName } = match.params
  const title = React.useMemo(() => {
    switch (tabName) {
      case Tabs.Overview:
        return 'Billing - Overview - engageSPARK'
      case Tabs.Receipts:
        return 'Billing - Purchase Receipts - engageSPARK'
      case Tabs.Invoices:
        return 'Billing - Usage Statements - engageSPARK'
      default:
        return 'Billing - engageSPARK'
    }
  }, [tabName])

  if ((Object.values(Tabs) as string[]).indexOf(tabName) === -1) {
    return (
      <Layout title="Error - engageSPARK">
        <AuthHeader currentPage={PAGE.ACCOUNT.BILLING.INDEX} />
        <CardLayout>
          <ErrorLayout status={404}>
            <Typography>This page does not exist.</Typography>
            <Typography>
              We can help find your way back <Link to="/">home</Link>
            </Typography>
          </ErrorLayout>
        </CardLayout>
      </Layout>
    )
  }

  return (
    <AuthGuard
      fallback={
        <Layout title="Billing - engageSPARK">
          <AuthHeader currentPage={PAGE.ACCOUNT.BILLING.INDEX} />
          <div style={{ padding: 24, textAlign: 'center' }}>
            <Typography variant="h6">
              You don't have permission to access billing information. Contact your organization's manager or owner to
              gain access.
            </Typography>
          </div>
          <Notifications />
        </Layout>
      }
      path={match.path}
      requiredRoles={['owner', 'manager', 'customer_service']}
      url={match.url}
    >
      <Layout disableScrolling title={title}>
        <AuthHeader currentPage={PAGE.ACCOUNT.BILLING.INDEX} />
        <TotpGuard>
          <Billing tabName={tabName} />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}
